<template>
  <div>
    <img class="match-parent" alt="" v-for="(item, index) in images" :key="index" :src="item" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: []
    }
  },
  created() {
    let list = []
    var fileNames = require.context('/static/images/card', true, /\.*\.png|jpg$/).keys()
    let dir = process.env.NODE_ENV === 'production' ? './static/images/card/' : '/static/images/card/'
    fileNames.forEach(element => {
      let path = element.replace('./', dir);
      list.push(path)
    });
    this.images = list
  },
};
</script>

<style lang="scss" scoped>
.match-parent {
  width: 100%;
}
</style>
